import React, { useCallback } from 'react';
import BaseActionListItem from './index';
import Title from './title';
const ActionListLink = ({
  href,
  target = '_self',
  onClick = Function.prototype,
  description = '',
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string | undefined'.
  flagCode = null,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'IconGlyph | undefined'.
  iconGlyph = null,
  disabled = false,
  selected = false,
  ...otherProps
}) => {
  const LinkComponent = useCallback(
    ({ children }) => (
      <a className="ws-ui-action-list-link" href={href} target={target} onClick={onClick}>
        <Title>{children}</Title>
      </a>
    ),
    [href, target, onClick]
  );

  return (
    <BaseActionListItem
      description={description}
      flagCode={flagCode}
      iconGlyph={iconGlyph}
      disabled={disabled}
      selected={selected}
      {...otherProps}
      component={LinkComponent}
    />
  );
};

export default ActionListLink;
